import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 0,
    goal: 0,
    oz: 0,
    vol: 0,
    acid: 0,
    type: {
      value: "borax",
      name: "borax",
      multiplier: 849.271,
    },
    types: [
      {
        value: "borax",
        name: "borax",
        multiplier: 849.271,
      },
      {
        value: "boric acid",
        name: "boric acid",
        multiplier: 1309.52,
      },
      {
        value: "tetraborate pentahydrate",
        name: "tetraborate pentahydrate",
        multiplier: 1111.69,
      },
    ],
  },
  getters: {
    getBorate(state) {
      return state;
    },
  },
  mutations: {
    calcBorate(state, settings) {
      let gallons = util.getGallons(settings.volume, settings.unitType);
      state.oz = state.vol = state.acid = 0;
      if (state.tested < state.goal) {
        const delta = (state.goal - state.tested) * gallons;
        const temp = delta / state.type.multiplier;
        state.oz = util.getWeight(temp, settings.unitType);
        if (state.type.name === "boric acid") {
          state.vol = util.getVolume(temp * 1.075, settings.unitType);
          state.acid = 0;
        } else if (state.type.name === "tetraborate pentahydrate") {
          state.vol = util.getVolume(temp * 0.5296, settings.unitType);
          state.acid = util.getVolume(temp * 0.624, settings.unitType);
        } else {
          state.vol = util.getVolume(temp * 0.9586, settings.unitType);
          state.acid = util.getVolume(temp * 0.4765, settings.unitType);
        }
      } else if (state.tested > state.goal) {
        const p = 100 - (state.goal / state.tested) * 100 + 0.5;
        state.percent = Math.floor(p);
      }
    },
    setBorate(state, borate) {
      if (!borate) {
        return;
      }
      state.tested = Number(borate.tested) || Number(state.tested);
      state.goal = Number(borate.goal) || Number(state.goal);
      state.oz = borate.oz || state.oz;
      state.vol = borate.vol || state.vol;
      state.acid = borate.acid || state.acid;
      state.type = borate.type || state.type;
    },
  },
  actions: {
    async initBorate(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("borate")
        .get();
      const borate = doc.data();
      state.commit("setBorate", borate);
    },
    async saveBorate(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("borate")
        .set({
          tested: data.tested,
          goal: data.goal,
          oz: data.oz,
          vol: data.vol,
          acid: data.acid,
          type: data.type,
        });
      state.commit("setBorate", data);
    },
  },
};
